<template>
  <div class="header">
    <div class="cs_text_lg cs_align_left txt_title">{{institutionName}}—运营维护端</div>
    <div class="div_user_name cs_fr"
         @mouseover="isOptionDisplay1 = true"
         @mouseout="isOptionDisplay1 = false">
      <div class="cs_text_sm cs_title_primary cs_align_center cs_round txt_user_name">{{userName}}</div>
      <div class="div_btn_user_name" v-show="isOptionDisplay1"
           @mouseover="isOptionDisplay1 = true" @mouseout="isOptionDisplay1 = false">
        <div class="btn_user_name" @click="btnModifyPsw">修改密码</div>
        <div class="btn_user_name" @click="logout">退出登录</div>
      </div>
    </div>
    <button class="btn_change_system" type="button" @click="btnChangeSystem"></button>

    <!--切换系统弹窗，默认隐藏-->
    <div v-if="isDialogSystemShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:682px;height:372px;">
        <button @click="btnCloseDialog" class="btn_close_dialog_header" type="button"></button>
        <div class="title_dialog_header">请选择子系统</div>
        <div class="div_btn_dialog_header top_112">
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnModuleDialog(SYSTEM_VERIFY.SHOP)">门店端</button>
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnModuleDialog(SYSTEM_VERIFY.DISTRIBUTION)">配送中心端</button>
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnModuleDialog(SYSTEM_VERIFY.KITCHEN)">中央厨房端</button>
        </div>
        <div class="div_btn_dialog_header top_226">
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnModuleDialog(SYSTEM_VERIFY.MERCHANT)">旗下商户端</button>
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnSystemLogin(SYSTEM_VERIFY.MANAGE)">集团管理端</button>
          <button class="cs_text_lg ui_btn_common_lg btn_operation" type="button" @click="btnSystemLogin(SYSTEM_VERIFY.OPERATION)">运营维护端</button>
        </div>
      </div>
    </div>
    <!--选择门店等弹窗，默认隐藏-->
    <div v-if="isDialogShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:459px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info_red"></div>
          <div class="title_info">请选择{{moduleName}}</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="100%">{{moduleName}}名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in moduleList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="100%">{{item.name}}</td>
            </tr>
            <template v-if="PAGE_SIZE>moduleList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-moduleList.length)">
                <td width="40px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_common_gradient ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>
    <!--修改密码弹窗，默认隐藏-->
    <div v-if="isDialogPswShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:414px;height:386px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info_red"></div>
          <div class="title_info">修改密码</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">原密码</div>
          <input v-model="dialogPsw.psw" type="password" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44">
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">新密码</div>
          <input v-model="dialogPsw.pswNew" type="password" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44">
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">确认新密码</div>
          <input v-model="dialogPsw.pswConfirm" type="password" class="cs_input cs_radius_lg edtxt_info_search width_246">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogPsw.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost" @click="closeDialogPsw">取消</button>
          <button type="button" class="cs_btn ui_btn_common_gradient ui_margin_left_88" @click="confirmDialogPsw">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {logout, valid,modifyPassword} from '../assets/ajax/ajax'
  import StorageConst from "../assets/utils/StorageConst";
  import {WEBAPP_LIST,SYSTEM_VERIFY,SYSTEM_MODULE_LIST,input_verify} from "../assets/utils/constants"

  export default {
    name: "header-common",
    data: function () {
      return {
        isOptionDisplay1: false,
        userName: "",
        institutionName: "",
        isDialogSystemShow: false,
        systemId: "",
        isDialogShow: false,
        moduleName: "",
        moduleList: [],
        selectedId: "",
        logoSrc: "",
        isDialogPswShow: false,
        dialogPsw: {
          psw : "",
          pswNew : "",
          pswConfirm : "",
          hintDialog : "",
        },
        SYSTEM_VERIFY: SYSTEM_VERIFY,
        SYSTEM_MODULE_LIST: SYSTEM_MODULE_LIST,
        PAGE_SIZE:10,
      }
    },
    created: function () {
      this.userName = this.$cookies.get(StorageConst.COOKIE_STAFF_NAME);
      this.institutionName = this.$cookies.get(StorageConst.COOKIE_INSTITUTION_NAME);
      this.logoSrc = localStorage.getItem(StorageConst.LOCAL_LOGO_URL)+"?x-oss-process=style/mini";
    },
    methods: {
      //切换系统
      btnChangeSystem(){
        this.isDialogSystemShow = true;
      },
      btnModuleDialog(id){
        this.systemId = id;
        //获取模块列表
        valid.bind(this)(this.$cookies.get(StorageConst.COOKIE_TOKEN),this.systemId,(data) => {
          if(data.data.moduleList.length===1){
            this.$cookies.set(StorageConst.COOKIE_MODULE_ID, data.data.moduleList[0].id);
            this.btnSystemLogin(this.systemId);
          }else{
            let list = data.data.moduleList;
            list.forEach((item) => {
              item.isSelected = false;
            });
            this.moduleList = list;
            this.moduleName = SYSTEM_MODULE_LIST[this.systemId];
            this.isDialogShow = true;
          }
        }, (data) => {
        }, true);
      },
      btnConfirmDialog(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请选择登录"+this.moduleName);
          return;
        }
        this.$cookies.set(StorageConst.COOKIE_MODULE_ID, this.selectedId);
        this.btnSystemLogin(this.systemId);
      },
      btnSelectTableTrDialog(item){
        let selectedStatus = item.isSelected;
        this.moduleList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
        }else {
          this.selectedId = "";
        }
      },
      closeDialog(){
        this.isDialogShow= false;
        this.moduleList= [];
        this.selectedId= "";
        this.moduleName = "";
      },
      btnSystemLogin(id){
        if(id===SYSTEM_VERIFY.OPERATION){
          this.$router.push({path:'/'});
          return;
        }
        let appUrl = WEBAPP_LIST[id];
        this.closeDialog();
        this.btnCloseDialog();
        window.location.href = appUrl + "#/";
      },
      btnCloseDialog(){
        this.systemId = "";
        this.isDialogSystemShow = false;
      },
      logout() {
        logout.bind(this)((data) => {
          this.$cookies.set(StorageConst.COOKIE_TOKEN, "",0);
          this.$router.push({path:'/'}).catch(data => {  })
        }, (data)=> {
          this.$cookies.set(StorageConst.COOKIE_TOKEN, "",0);
          this.$router.push({path:'/'}).catch(data => {  })
        }, true);
      },
      btnModifyPsw(){
        this.isDialogPswShow = true;
      },
      confirmDialogPsw(){
        if(this.isEmpty(this.dialogPsw.psw)){
          this.dialogPsw.hintDialog = "原密码不能为空，请重新输入";
          return;
        }
        if(!this.verifyStringInRange(this.dialogPsw.pswNew, "新密码",8,32,false)){
          this.dialogPsw.hintDialog = "新密码至少由8位数字、字母、符号组成，请重新输入";
          return;
        }
        if(!this.verifyStringInRange(this.dialogPsw.pswConfirm, "确认新密码",8,32,false)){
          this.dialogPsw.hintDialog = "新密码至少由8位数字、字母、符号组成，请重新输入";
          return;
        }
        // if(!this.validate(this.dialogPsw.pswNew,input_verify.TYPE_LETTER  | input_verify.TYPE_NUMERIC | input_verify.TYPE_SPECIAL_CHAR)){
        //   this.dialogPsw.hintDialog = "新密码至少由8位数字、字母、符号组成，请重新输入";
        //   return;
        // }
        if(this.dialogPsw.pswNew!==this.dialogPsw.pswConfirm){
          this.$toast("新密码与确认密码输入不一致！");
          return;
        }
        console.log(1);
        modifyPassword.bind(this)(this.dialogPsw.psw,this.dialogPsw.pswNew,(data) => {
          this.$toast("密码修改成功！");
          this.closeDialogPsw();
        }, (data) => {
        }, true);
      },
      closeDialogPsw(){
        this.isDialogPswShow= false;
        this.dialogPsw= {
          psw : "",
          pswNew : "",
          pswConfirm : "",
          hintDialog : "",
        };
      },
    }
  }
</script>

<style scoped>
  .header {
    position: fixed;
    top: 0;
    width: calc(100% - 242px);
    _width: 350px;
    min-width: 350px;
    height: 66px;
    background-color: #FFFFFF;
    box-shadow: 0 5px 7px 3px rgba(100, 143, 232, 0.06);
    z-index: 100;
  }
  .img_logo_header{
    position: absolute;
    top: 15px;
    left: 140px;
    width: 40px;
    height: 36px;
    cursor: pointer;
  }
  .txt_title {
    position: absolute;
    left: 32px;
    height: 66px;
    line-height: 66px;
    color: #757575;
    font-weight: bold;
  }
  .btn_change_system {
    position: absolute;
    right: 35px;
    top: 20px;
    width: 26px;
    height: 26px;
    background: url("../assets/image/icon_change_system.png") no-repeat center;
    background-size: 26px 26px;
  }
  .btn_change_system:hover,.btn_change_system:active{
    background: url("../assets/image/icon_change_system_hover.png") no-repeat center;
    background-size: 26px 26px;
  }
  .div_user_name {
    margin-right: 85px;
    margin-top: 21px;
    _width: 80px;
    min-width: 80px;
    height: 40px;
  }
  .txt_user_name {
    position: relative;
    _width: 80px;
    min-width: 80px;
    height: 24px;
    padding: 0 10px;
    line-height: 24px;
    background: rgba(148, 161, 187, 0.14);
    cursor: pointer;
  }
  .div_btn_user_name {
    position: relative;
    margin-top: 8px;
    width: 100%;
    border-top: solid 1px #eeeeee;
    border-left: solid 1px #eeeeee;
    border-right: solid 1px #eeeeee;
    background: #ffffff;
  }
  .btn_user_name {
    position: relative;
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #666666;
    background-color: #ffffff;
    border-bottom: solid 1px #eeeeee;
    text-align: center;
    cursor: pointer;
  }
  .btn_user_name:hover, .btn_user_name:active {
    color: #333333;
    background-color: rgba(255,181,76,0.05);
  }
  .btn_close_dialog_header{
    position: absolute;
    right: 24px;
    top: 24px;
    width: 20px;
    height: 20px;
    background: url("../assets/image/bg_btn_close.png") no-repeat center;
    background-size: 20px 20px;
  }
  .title_dialog_header{
    position: absolute;
    top: 40px;
    width: 100%;
    height: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .div_btn_dialog_header {
    position: absolute;
    width: 100%;
    height: 82px;
    font-size: 0;
    text-align: center;
  }
  .top_112{top: 112px}
  .top_226{top: 226px}
  .btn_operation {
    position: relative;
    display: inline-block;
    margin-left: 24px;
    width: 158px;
    height: 82px;
  }
  .btn_operation:first-child {margin-left: 0;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .width_246{width: 246px;}
  .margin_left_18{margin-left: 18px;}
  .margin_top_12{margin-top: 12px;}
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/components/header-common.vue